import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import AccessGate from "../../components/permissions/AccessGate";
import {
    deleteContentWriterArticle,
    loadContentWriterArticles,
    loadContentWriterProject
} from "../../actions/content_writer";
import {displayErrors} from "../../libs/utils";
import {Card, Col, message, Popconfirm, Row, Select, Space, Table, Tag, Tooltip} from "antd";
import AccessItem from "../../components/permissions/AccessItem";
import Button from "antd/es/button";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {DeleteOutlined, SettingOutlined} from "@ant-design/icons";
import {DEFAULT_DOMAINS_PER_PAGE} from "../../config";
import {Link} from "react-router-dom";
import ProjectSettings from "../../components/content/ProjectSettings";
import {DateTimeFormat} from "../../components/shared/DateTimeFormat";
import {hasPermission} from "../../components/permissions/PermissionUtils";

class ContentProject extends React.Component {
    state = {
        articles: [],
        filters: null,
        loadingArticles: false,
        searchQuery: [],
        searching: false,
        pagination: { current: 1, pageSize: DEFAULT_DOMAINS_PER_PAGE, showSizeChanger: true, total: 0 },
        showNotesModal: false,
        showSettingsModal: false,
        creatingArticle: false,
    };

    componentDidMount() {
        this.loadProject();
        this.loadArticles();
    }

    loadProject() {
        this.props.loadContentWriterProject(this.props.match.params.guid, (res) => {
            this.props.updatePage(<span>{res.data.name} <Tag color='warning'>Beta</Tag></span>);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        })
    }

    loadArticles(page = null, per_page = null, filters = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        } else {
            if(per_page !== this.state.pagination.pageSize) {
                page = 1;
            }
        }

        if(filters === null) {
            filters = this.state.filters;
        }

        if(this.state.searchQuery.length > 0) {
            page = 1;
            this.setState({ searching: true });
        }

        this.setState({ loadingArticles: true });

        this.props.loadContentWriterArticles(this.props.match.params.guid, page, per_page, this.state.searchQuery, filters, (response) => {
            this.setState({ articles: response.data.data,
                pagination: { current: response.data.page, pageSize: response.data.per_page, showSizeChanger: true, total: response.data.total }, loadingArticles: false, searching: false });
        }, (err) => {
            this.setState({ loadingArticles: false, searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    clearSearchAndLoadArticles() {
        this.setState({ searchQuery: []}, () => {
            this.loadArticles();
        });
    }

    runSearch() {
        if(this.state.searchQuery.length > 0) {
            this.loadArticles();
        }
    }

    updateSearchQuery(value) {
        if(value.length === 0) {
            return this.setState({ searchQuery: [] }, () => this.loadArticles());
        }

        let query = [];

        for(let i = 0; i < value.length; i++) {
            let item = value[i].trim();

            if(item !== '') {
                query.push(item)
            }
        }

        this.setState({ searchQuery: query });

        if(query.length === 0) {
            this.loadArticles();
        }
    }

    deleteArticle(guid) {
        this.setState({ loadingArticles: true });

        this.props.deleteContentWriterArticle(this.props.match.params.guid, guid, () => {
            message.success('Article deleted successfully');
            this.loadArticles();
        }, (err) => {
            this.setState({ loadingArticles: false, searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const columns = [
            { title: 'Title', dataIndex: 'title', width: '60%', render: (item, record) => <Link to={'/content/' + this.props.match.params.guid + '/articles/' + record.guid}>{item}</Link> },
            { title: 'Created', dataIndex: 'date_created', render: (value) => <DateTimeFormat value={value} /> },
            { title: 'Updated', dataIndex: 'date_updated', render: (value) => <DateTimeFormat value={value} /> },
        ];

        if(hasPermission(this.props.company.permissions, ['can_use_content_writer'])) {
            columns.push({ title: '', align: 'right', render: (item, record) => (
                    <Popconfirm
                        title="Are you sure you want to delete this article?"
                        onConfirm={() => this.deleteArticle(record.guid)}
                        okText='Delete'
                        placement='topLeft'
                        okButtonProps={{danger: true}}
                        cancelText='Cancel'>
                        <Tooltip title='Delete article' placement='left'>
                            <Button icon={<DeleteOutlined />} danger size='small' />
                        </Tooltip>
                    </Popconfirm>
                )});
        }

        return <AccessGate scopes={['can_view_content_writer']}>
            <Card size='small'>
                <Row justify='space-between' style={{paddingBottom: '10px'}}>
                    <Col>
                        <Space>
                            <AccessItem scopes={['can_use_content_writer']}>
                                <Space>
                                    <Link to={'/content/' + this.props.match.params.guid + '/articles'}><Button type='primary' icon={<PlusOutlined />}>Add Article</Button></Link>
                                    <Button icon={<SettingOutlined />} onClick={() => this.setState({ showSettingsModal: true })}>Project Settings</Button>
                                </Space>
                            </AccessItem>

                            <Select
                                value={this.state.searchQuery}
                                maxTagCount={50}
                                placeholder='Search articles...'
                                open={false}
                                maxTagTextLength={10}
                                onClear={() => this.clearSearchAndLoadArticles()}
                                onInputKeyDown={(e) => { if(e.key === 'Enter') { this.runSearch() }}}
                                allowClear loading={this.state.searching}
                                mode="tags" style={{ width: '250px' }}
                                onChange={(value) => this.updateSearchQuery(value)} tokenSeparators={[',', ' ']} />
                        </Space>
                    </Col>
                    <Col><Tooltip title='Reload table'><Button type='text' icon={<UndoOutlined />} onClick={() => this.loadArticles()}/></Tooltip></Col>
                </Row>

                <div style={{overflowX: 'auto'}}>
                    <Table
                        dataSource={this.state.articles}
                        columns={columns}
                        rowKey={(item) => item.guid}
                        pagination={this.state.pagination}
                        onChange={(pagination) => this.loadArticles(pagination.current, pagination.pageSize)}
                        loading={this.state.loadingArticles}/>
                </div>
            </Card>

            <ProjectSettings
                projectId={this.props.match.params.guid}
                showModal={this.state.showSettingsModal}
                close={() => this.setState({showSettingsModal: false})}
                reload={() => this.loadProject()}
            />
        </AccessGate>;
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, {
    updatePage, loadContentWriterProject,
    loadContentWriterArticles, deleteContentWriterArticle
})(ContentProject);